import { QueryModel, SearchModel, SortModel } from '../DataTableQuery.types';

export namespace QueryVariablePreprocessor {
  export enum Status {
    NOT_STARTED = 'NOT_STARTED',
    IN_PROGRESS = 'IN_PROGRESS',
    COMPLETED = 'COMPLETED'
  }

  export interface Result<Q extends QueryModel = QueryModel, S extends SortModel = SortModel> {
    result: SearchModel<Q, S> | null;
    status: Status;
  }

  export type Function = <Q extends QueryModel = QueryModel, S extends SortModel = SortModel>(
    prevResult: Result<Q, S> | null
  ) => Result<Q, S>;
}
